export default "__VITE_ASSET__3dd7538b__"